/**
 * Достает из объекта значение вложенного свойства
 * @param object объект
 * @param path путь к свойству
 * @param sep сепаратор пути к свойству
 */
export const dp = (object: any, path: string, sep = '.'): any => {
  return path.split(sep).reduce((acc, curr) => acc[curr], object);
};
